// extracted by mini-css-extract-plugin
export default {"modal":"Modals_modal__hxZX-","modalBody":"Modals_modalBody__P4wam","mt10":"Modals_mt10__oQ1W1"};